import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcessoPessoalComponent } from './acesso-pessoal.component';
import { AuthGuardService } from 'src/app/shared/services/auth.service';
import { FormAcessoPessoalComponent } from './form-acesso-pessoal/form-acesso-pessoal.component';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';

const routes: Routes = [
    {
        path: ConstantsRotasDoSistema.ACESSO_PESSOAL,
        canActivate: [AuthGuardService],
        children: [
            {
                path: '',
                component: AcessoPessoalComponent,
            },
            {
                path: 'novo',
                component: FormAcessoPessoalComponent,
            },
            {
                path: ':id',
                component: FormAcessoPessoalComponent,
            },
        ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AcessoPessoalRoutingModule { }
